// /faqs — the questions come from the FAQs table in Airtable (via /api/faqs,
// served from the backend's file cache) so Claire edits them without a deploy.
// The hand-written page in content/pages/faqs.js stays as the fallback: it's
// what renders while the request is in flight and if the API has nothing,
// and its hero and closing "Still Have Questions?" band are reused here so
// the two never drift apart in look.

import { useEffect, useState } from 'react';
import ContentPage from 'pages/ContentPage';
import PAGES from 'content/pages';
import { toFaqParts } from 'utils/lightMarkup';

const API = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';
const LOCAL = PAGES.faqs;

// Airtable sections → the heading + faq blocks ContentPage already renders.
function blocksFromSections(sections) {
  const blocks = [];
  sections.forEach((s) => {
    if (!s.items?.length) return;
    blocks.push({ type: 'heading', level: 'band', text: s.title });
    blocks.push({ type: 'faq', items: s.items.map((it) => ({ q: it.q, a: toFaqParts(it.a) })) });
  });
  // Keep whatever closes the local page (the Still Have Questions band).
  const tail = LOCAL.blocks.filter((b) => b.type === 'ctaGroup');
  return [...blocks, ...tail];
}

export default function FaqsPage() {
  const [page, setPage] = useState(LOCAL);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/faqs`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!alive || !Array.isArray(data?.sections) || !data.sections.length) return;
        setPage({ ...LOCAL, blocks: blocksFromSections(data.sections) });
      })
      .catch(() => { /* keep the local copy */ });
    return () => { alive = false; };
  }, []);

  return <ContentPage page={page} />;
}
